import { Paper, Typography } from "@mui/material"
import { memo } from "react"

interface EmptyViewProps {
    isSquareOff?: boolean
}

const EmptyView: React.FC<EmptyViewProps> = ({ isSquareOff = false }) => {

    return <Paper sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Typography variant="body2" sx={{color: 'textSecondary'}}>{isSquareOff ? "All positions have been added for square off" : "No Strategy Selected, Build/Select a one by to analyze"}</Typography>
    </Paper>
}

export default memo(EmptyView)